module.exports = __webpack_public_path__ + "img/rutas-icon.3dee2c69.svg";